import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Table, Btn } from "@/components/UI";
import { Truck } from "lucide-react";
import { ExplicitFilterBar } from "@/components/common/ExplicitFilterBar";
import { DeliverModal } from "@/components/shipping/DeliverModal";
import { trDate } from "@/lib/sales";
import { fmtNum, fmtQty, toQuery } from "@/lib/products";
import { apiError } from "@/lib/customers";
import { LabelButtons } from "@/components/shipping/LabelButtons";

const DS = {
  pending: { label: "Bekliyor", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  partial: { label: "Kısmi Teslim", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completed: { label: "Tamamlandı", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};
const INITIAL = { q: "", status: "" };
const FIELDS = [
  { key: "q", label: "Sipariş No / Müşteri", width: "w-64" },
  { key: "status", label: "Teslim Durumu", type: "select", width: "w-40", options: [{ value: "", label: "Tümü" }, ...Object.entries(DS).map(([k, v]) => ({ value: k, label: v.label }))] },
];

export default function ShippingPage() {
  const [rows, setRows] = useState([]);
  const [filters, setFilters] = useState(INITIAL);
  const [open, setOpen] = useState(null);
  const [err, setErr] = useState("");
  const load = (f = filters) => api.get(`/shipping/orders${toQuery(f)}`).then((r) => { setRows(r); setErr(""); })
    .catch((e) => setErr(apiError(e, "Sevkiyat listesi yüklenemedi")));
  useEffect(() => { load(INITIAL); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="shipping-page">
      <PageHeader title="Sevkiyat" description="Onaylı satış siparişlerinin teslimatı — her satır bir sipariş" />
      <ExplicitFilterBar fields={FIELDS} initial={INITIAL} onApply={(f) => { setFilters(f); load(f); }} testid="ship-filter" />
      {err && <div className="mb-3 text-sm text-rose-600" data-testid="ship-load-error">{err}</div>}
      <Table testid="shipping-table" empty="Teslim edilecek onaylı sipariş yok"
        columns={[
          { label: "Sipariş No", render: (r) => <span className="font-mono text-xs font-semibold" data-testid={`ship-row-no-${r.id}`}>{r.so_no}</span> },
          { label: "Müşteri", render: (r) => <span className="font-medium">{r.customer_name}</span> },
          { label: "Sipariş Tarihi", render: (r) => trDate(r.order_date) },
          { label: "Toplam Sipariş", render: (r) => `${fmtNum(r.grand_total)} TRY` },
          { label: "Teslim Durumu", render: (r) => (
            <span className={`inline-block px-2 py-0.5 rounded-md border text-[11px] font-semibold ${DS[r.delivery_status].cls}`} data-testid={`ship-row-status-${r.id}`}>
              {DS[r.delivery_status].label} · {fmtQty(r.delivered_total)}/{fmtQty(r.physical_total)}
            </span>
          ) },
          { label: "İşlem", render: (r) => (
            <div className="flex flex-wrap gap-1">
              <Btn size="sm" onClick={() => setOpen(r.id)} data-testid={`ship-deliver-${r.id}`}><Truck size={12} /> {r.delivery_status === "completed" ? "Geçmiş" : "Teslim Et"}</Btn>
              <LabelButtons orderId={r.id} soNo={r.so_no} status={r.status || "approved"} size="sm" testid="ship-label" />
            </div>
          ) },
        ]}
        rows={rows} />
      <DeliverModal orderId={open} onClose={() => setOpen(null)} onDone={() => load()} />
    </div>
  );
}
